import { GET_NEWSS, ERROR_NEWS, GET_NEWS } from "../actions";

const inialState = {
  newss: [],
  news: null,
  loading: true,
  error: {},
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = inialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_NEWSS:
      return {
        ...state,
        newss: payload,
        loading: false,
      };
    case GET_NEWS:
      return {
        ...state,
        news: payload,
        loading: false,
      };
    case ERROR_NEWS:
      return {
        ...state,
        error: payload,
        loading: false,
      };

    default:
      return state;
  }
}
